import React, { FC, PropsWithChildren, ReactNode } from 'react';

import { ReactComponent as AlertIcon } from 'icons/alert-circle.svg';
import styles from './FieldWrapper.module.scss';

interface Props {
  error?: string | boolean,
  label?: ReactNode,
}

const FieldWrapper: FC<PropsWithChildren<Props>> = ({ error, label, children }) => {
  return (
    <div className={styles.wrapper}>
      <label>
        <div className={styles.label}>{label}</div>
        <div className={styles.field}>
          {children}
          {error && (
            <div className={styles.error}>
              <AlertIcon className={styles.errorIcon} />
              <div className={styles.errorText}>{error}</div>
            </div>
          )}
        </div>
      </label>
    </div>
  );
};

export default FieldWrapper;
